// Import model
import { DataviewLeadTypeResponse } from '../models/DataviewLeadTypeResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterLeadTypeRequest } from '../models/FilterLeadTypeRequest';
import { LeadType } from '../models/LeadType';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterLeadTypeRequestSerializer } from './FilterLeadTypeRequestSerializer';
import { LeadTypeSerializer } from './LeadTypeSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewLeadTypeResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewLeadTypeResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewLeadTypeResponse instance
   */
  static deserialize(json: string): DataviewLeadTypeResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewLeadTypeResponse instance
   */
  static fromObject(obj: any): DataviewLeadTypeResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewLeadTypeResponse');
    }


    const instance: DataviewLeadTypeResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        LeadTypeSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterLeadTypeRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewLeadTypeResponse instances
   */
  static deserializeArray(json: string): DataviewLeadTypeResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewLeadTypeResponse instance to a JSON string
   */
  static serialize(instance: DataviewLeadTypeResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewLeadTypeResponse instance to a plain object
   */
  static toObject(instance: DataviewLeadTypeResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        LeadTypeSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterLeadTypeRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewLeadTypeResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewLeadTypeResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
